export const rangeFunction=(end)=>{
    return [...Array(end).keys()].map((x,i)=>i+1)
}
